module.exports = __webpack_public_path__ + "img/clear_cache.c4c7acac.svg";